import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as formReducer } from 'redux-form';
import authReducer from './auth';
import frontReducer from './front';
import statusReducer from './status';
import lookupReducer from './lookup';

export const rootReducer = combineReducers({
    form: formReducer,
    routing: routerReducer,
    authentication: authReducer,
    frontend: frontReducer,
    status: statusReducer,
    lookup: lookupReducer,
    gaSettings: (state = {}) => state,
    socialDataMock: (state = {}) => state,
    isCheckoutRequest: (state = false) => state,
});
